module.exports = __webpack_public_path__ + "img/przewod-do-ladowania.3ba2a648.jpg";